import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetSentEmailsBySearch(club, url) {

  var url = "/reservation/get_mail_by_search/" + club + "/" + url; 

  return FetchGetDataWithAuthNEW(url);
}

